import { SubpropertyModel } from '@modules/subproperty/subproperty-model';

const { fields } = SubpropertyModel;

export default [
  fields.id,
  fields.name,
  fields.status,
  fields.createdAt
];
